var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M6 9 1.5 4.71 2.21 4 6 7.59 9.79 4l.71.71z"
  })));
};
export { SvgArrowDown as Icon };
export default __webpack_public_path__ + "static/media/220a5f587ab36f62ec03bba137548ea1.svg";